import React from 'react'
import MetaTags from '../../elements/meta/metaTags.js'
import { Helmet } from 'react-helmet'

const HomeMeta = () => (
  <>
    <MetaTags
      title="Motorcycle Rental Across USA | Twisted Road"
      description="At Twisted Road, we make motorcycle rentals easy. Whether on our rental app or on the web, we are confident you can find your dream motorcycle to rent."
      ogDescription="At Twisted Road, we make motorcycle rentals easy. Whether on our rental app or on the web, we are confident you can find your dream motorcycle to rent."
      url={''}
      type="company"
      notShowKeywords={true}
    />
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          url: 'https://www.twistedroad.com/',
          logo:
            'https://res.cloudinary.com/twisted-road/image/upload/c_fill,g_center,q_auto,f_auto/v1567103895/frontend_assets/seo/twisted-road-logo-black-seo.png',
          sameAs: [
            'https://www.twitter.com/twistedroad_',
            'https://www.instagram.com/twistedroad/',
            'https://www.facebook.com/ridetwistedroad/',
          ],
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ProfessionalService',
          name: 'Twisted Road',
          image:
            'https://www.twistedroad.com/static/media/twistedroad-logo.7bcbeefa.png',
          '@id': '',
          url: 'https://www.twistedroad.com/',
          telephone: '',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '',
            addressLocality: '',
            postalCode: '',
            addressCountry: 'US',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 45.1575501,
            longitude: -128.1448585,
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: [
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
              'Sunday',
            ],
            opens: '00:00',
            closes: '23:59',
          },
          sameAs: [
            'https://www.facebook.com/ridetwistedroad/',
            'https://twitter.com/twistedroad_',
            'https://www.instagram.com/twistedroad/',
          ],
        })}
      </script>
    </Helmet>
  </>
)

export default HomeMeta
